
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-520 108 90 90"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"-475","cy":"153","r":"45","fill":"#139bd0"}}),_c('path',{attrs:{"d":"M-473.5 163.8c-1.7 1.7-3.5 3.3-5.2 5-.6.6-1.3.9-2.1.9-.6 0-.9-.3-1.1-.8-1.3-4-2.6-8.1-3.9-12.1-.1-.4-.3-.6-.7-.7-3.1-.9-6.1-1.9-9.2-2.9-.5-.2-.9-.3-1.4-.6-.6-.4-.7-1.1-.2-1.6.5-.5 1.1-.9 1.8-1.1 3.8-1.5 7.5-2.9 11.3-4.4 9.6-3.7 19.1-7.4 28.7-11.1 1.8-.7 3.2.3 3 2.3-.1 1.3-.4 2.5-.7 3.7-2.1 9.8-4.2 19.6-6.2 29.4-.5 2.3-2.1 2.9-4 1.5-3.2-2.4-6.4-4.7-9.6-7.1-.2-.2-.4-.3-.5-.4zm-7.2 2.9h.1c0-.1 0-.2.1-.3.2-2.2.4-4.4.6-6.7 0-.5.2-.8.6-1.2 3-2.6 5.9-5.3 8.8-8 3.3-2.9 6.5-5.9 9.8-8.8.2-.2.3-.5.4-.7-.3 0-.6-.2-.9-.1-.4.1-.7.3-1.1.5-7.2 4.5-14.4 9.1-21.6 13.6-.4.3-.5.5-.3.9.5 1.5 1 3.1 1.5 4.6.6 2.1 1.3 4.2 2 6.2z","fill":"#fff"}})])
          )
        }
      }
    